module.exports = __webpack_public_path__ + "img/btn_close.c8a7c40f.png";